import { n as handleModelFilterInteraction, t as handleFilterInteraction } from "./filter-DERodJ0X.js";
//#region src/scripts/extenders/filter-segment.js
var filterSegment = class extends HTMLElement {
	constructor() {
		super();
		this.querySelectorAll(".js-checkbox")?.forEach((checkbox) => {
			checkbox.addEventListener("change", (event) => {
				const checked = event.target.checked;
				const value = event.target.value;
				const param = event.target.dataset.param;
				if (checked && param === "models") {
					handleModelFilterInteraction(value);
					return;
				}
				if (checked && param !== "models") handleFilterInteraction(param, value, true);
				else handleFilterInteraction(param, value, false);
			});
		});
	}
};
if (customElements.get("filter-segment") === void 0) customElements.define("filter-segment", filterSegment);
//#endregion
